import { Observable } from 'rxjs';

import type { ExtendedApiResponse, SupportedCoinDto, SupportedCoinsResponse } from '@coin-depo-types';

export interface CoinFacade {
  cachedSupportedCoins$: Observable<SupportedCoinDto[]>;
  allCachedSupportedCoins$: Observable<SupportedCoinDto[]>;

  getSupportedCoinsByIdSnapshot(
    id: string | number
  ): SupportedCoinDto | undefined;

  updateSupportedCoins(): Observable<
    ExtendedApiResponse<SupportedCoinsResponse>
  >;

  getSupportedCoinsSnapshot(): SupportedCoinDto[];

  getSupportedCoinsByNameSnapshot(name: string): SupportedCoinDto | undefined;
  
  getSupportedCoinsByLogoName(name: string): SupportedCoinDto | undefined;

  getVestingCSV?(coin_id: number): Observable<Blob>;
  getVestingCSVAdmin?(payload: { coin_id: number, user_user_id: number }): Observable<Blob>;
}
